<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <form class="form-horizontal mt-3">
        <div class="row">
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-6">
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.province'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <select
                      v-model.number="model.province_code"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('province_code') }"
                      @change="provinceChange(model.province_code)"
                      @input="
                        model.district_code = model.commune_code = model.village_code = null
                      "
                    >
                      <option
                        :value="null"
                        disabled
                        selected
                        style="display: none;"
                        >{{ $t('select') }}</option
                      >
                      <option
                        v-for="(province, index) in provinces"
                        :key="index"
                        :value="province.province_code"
                      >
                        {{ province.province_name }} |
                        {{ province.province_name_native }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('province_code')"
                    >
                      {{ errors.first('province_code') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.district'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <ts-loading-banner :loading="province_change">
                      <select
                        v-model.number="model.district_code"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('district_code') }"
                        @change="districtChange(model.district_code)"
                        @input="model.commune_code = null"
                      >
                        <option
                          :value="null"
                          disabled
                          selected
                          style="display: none;"
                          >{{ $t('select') }}</option
                        >
                        <option
                          v-for="(district, index) in districts"
                          :key="index"
                          :value="district.district_code"
                        >
                          {{ district.district_name }} |
                          {{ district.district_name_native }}
                        </option>
                      </select>
                    </ts-loading-banner>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('district_code')"
                    >
                      {{ errors.first('district_code') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.commune'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <ts-loading-banner :loading="district_change">
                      <select
                        v-model.number="model.commune_code"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('commune_code') }"
                        @change="communeChange(model.commune_code)"
                        @input="model.village_code = null"
                      >
                        <option
                          :value="null"
                          disabled
                          selected
                          style="display: none;"
                          >{{ $t('select') }}</option
                        >
                        <option
                          v-for="(commune, index) in communes"
                          :key="index"
                          :value="commune.commune_code"
                        >
                          {{ commune.commune_name }} |
                          {{ commune.commune_name_native }}
                        </option>
                      </select>
                    </ts-loading-banner>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('commune_code')"
                    >
                      {{ errors.first('commune_code') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.village'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <ts-loading-banner :loading="commune_change">
                      <select
                        v-model.number="model.village_code"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('village_code') }"
                      >
                        <option
                          :value="null"
                          disabled
                          selected
                          style="display: none;"
                          >{{ $t('select') }}</option
                        >
                        <option
                          v-for="(village, index) in villages"
                          :key="index"
                          :value="village.village_code"
                        >
                          {{ village.village_name }} |
                          {{ village.village_name_native }}
                        </option>
                      </select>
                    </ts-loading-banner>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('village_code')"
                    >
                      {{ errors.first('village_code') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.street'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <input
                      type="text"
                      v-model="model.street_no"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('street_no') }"
                    />
                    <div
                      v-if="errors.has('street_no')"
                      class="invalid-feedback"
                    >
                      {{ errors.first('street_no') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.house'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <input
                      type="text"
                      v-model="model.house_no"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('house_no') }"
                    />
                    <div v-if="errors.has('house_no')" class="invalid-feedback">
                      {{ errors.first('house_no') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.placeOfBirth'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <textarea
                      type="text"
                      v-model="model.place_of_birth"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('place_of_birth') }"
                      rows="3"
                    ></textarea>
                    <div
                      v-if="errors.has('place_of_birth')"
                      class="invalid-feedback"
                    >
                      {{ errors.first('place_of_birth') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.placeOfBirthKh'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <textarea
                      type="text"
                      v-model="model.place_of_birth_kh"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('place_of_birth_kh') }"
                      rows="3"
                    ></textarea>
                    <div
                      v-if="errors.has('place_of_birth_kh')"
                      class="invalid-feedback"
                    >
                      {{ errors.first('place_of_birth_kh') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3"></div>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'address-form',
  props: ['value', 'validate', 'clear'],
  data () {
    return {
      model: {},
      loadingPreData: false,
      errors: new Errors(),
      province_change: false,
      district_change: false,
      commune_change: false
    }
  },
  created () {
    this.fetchResourceBeforeCreate()
    this.model = this.value
  },
  computed: {
    ...mapState('studentProfile', [
      'provinces',
      'districts',
      'communes',
      'villages',
      'edit_data'
    ])
  },
  methods: {
    ...mapActions('studentProfile', [
      'getDistrict',
      'getCommune',
      'getVillage'
    ]),
    async fetchResourceBeforeCreate () {
      this.loadingPreData = true
      await this.$store
        .dispatch('studentProfile/dataForSchoolInformation')
        .then(() => {
          this.model = this.value
          this.setEditData()
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    async provinceChange (province_code) {
      this.province_change = true
      await this.getDistrict(province_code)
      this.province_change = false
    },

    async districtChange (district_code) {
      this.district_change = true
      await this.getCommune(district_code)
      this.district_change = false
    },

    async communeChange (commune_code) {
      this.commune_change = true
      await this.getVillage(commune_code)
      this.commune_change = false
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.model.student_id = this.edit_data.student_id
        this.model.province_code = this.edit_data.province_code
        this.model.district_code = this.edit_data.district_code
        this.model.commune_code = this.edit_data.commune_code
        this.model.village_code = this.edit_data.village_code
        this.model.street_no = this.edit_data.street_no
        this.model.house_no = this.edit_data.house_no
        this.model.place_of_birth = this.edit_data.place_of_birth
        this.model.place_of_birth_kh = this.edit_data.place_of_birth_kh
      }
    }
  },
  watch: {
    validate: {
      handler () {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    'model.province_code': function (value) {
      if (value) {
        this.getDistrict(value)
      }
    },
    'model.district_code': function (value) {
      if (value) {
        this.getCommune(value)
      }
    },
    'model.commune_code': function (value) {
      if (value) {
        this.getVillage(value)
      }
    },
    clear: function (value) {
      if (value == true) {
        this.model = this.value
      }
    }
  }
}
</script>
